import api from "./api";

class TopicService {
  /**************************************
   *  API FBO
   **************************************/
  async addTopic(formData) {
    const config = {
      transformRequest: (data) => {
        // Prevent Axios from modifying FormData
        if (data instanceof FormData) return data;
        return JSON.stringify(data);
      },
      headers: {
        'Content-Type': undefined // Let browser set multipart boundary
      }
    };

    try {
      const response = await api.post("/blog/topics/create/", formData, config);
      return {
        status: response.status,
        data: response.data
      };
    } catch (error) {
      return {
        status: error.response?.status || 500,
        data: error.response?.data || { message: error.message }
      };
    }
  }

  async updateTopic(id, formData) {
    const config = {
      transformRequest: (data) => {
        if (data instanceof FormData) return data;
        return JSON.stringify(data);
      },
      headers: {
        'Content-Type': undefined // Let browser set boundary
      }
    };

    try {
      const response = await api.put(`/blog/topics/update/${id}/`, formData, config);
      return {
        status: response.status,
        data: response.data
      };
    } catch (error) {
      return {
        status: error.response?.status || 500,
        data: error.response?.data || { message: error.message }
      };
    }
  }

  async getAllTopics(params) {
    return await api
      .get("/blog/topics/list", { params })
      .then((response) => {
        return { status: response.status, data: response.data };
      })
      .catch(function (error) {
        return { status: error.response.status, data: error.response.data };
      });
  }

  async getTopic(id) {
    return await api
      .get("/blog/topics/" + id)
      .then((response) => {
        return { status: response.status, data: response.data };
      })
      .catch(function (error) {
        return { status: error.response.status, data: error.response.data };
      });
  }

  async deleteTopic(id) {
    return await api
      .delete("/blog/topics/delete/" + id + "/")
      .then((response) => {
        return { status: response.status, data: response.data };
      })
      .catch(function (error) {
        return { status: error.response.status, data: error.response.data };
      });
  }

  async updateTopicsOrder(topics) {
    return await api
      .post("/blog/topics/order/update", { topics })
      .then((response) => {
        return { status: response.status, data: response.data };
      })
      .catch((error) => {
        return {
          status: error.response?.status || 500,
          data: error.response?.data || { error: "Error inesperado" },
        };
      });
	}
}

export default new TopicService();
